export default "__VITE_ASSET__ZeS9ix7x__"